"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const HeroSmallDevice_1 = __importDefault(require("./HeroSmallDevice"));
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => ({}));
exports.default = connector(({}) => {
    const [navToggle, setNavToggle] = (0, react_1.useState)(false);
    const [contentAnimation, setContentAnimation] = (0, react_1.useState)(false);
    const [markerAnimation, setMarkerAnimation] = (0, react_1.useState)(false);
    const [popoverAnimation, setPopoverAnimation] = (0, react_1.useState)(false);
    function navToggleHandler() {
        setNavToggle((prevState) => !prevState);
    }
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        const markerTimeOut = setTimeout(() => {
            setMarkerAnimation(true);
        }, 500);
        const popoverTimeout = setTimeout(() => {
            setPopoverAnimation(true);
        }, 1500);
        const contentTimeout = setTimeout(() => {
            setContentAnimation(true);
        }, 500);
        return () => {
            clearTimeout(markerTimeOut);
            clearTimeout(popoverTimeout);
            clearTimeout(contentTimeout);
        };
    }, []);
    //s-curve-clip
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeroSmallDevice_1.default, null),
        react_1.default.createElement("div", { className: "hero_main_container" },
            react_1.default.createElement("div", { className: "hero_inner_container" },
                react_1.default.createElement("div", { className: "hero_top_container" },
                    react_1.default.createElement("div", { className: "hero_logo_container" },
                        react_1.default.createElement("img", { src: "/assets/images/swivvl_logo_1.png", alt: "logo" })),
                    react_1.default.createElement("div", { className: "hero_nav_lists" },
                        react_1.default.createElement("ul", null)),
                    react_1.default.createElement("div", { className: "hero_button_container" },
                        react_1.default.createElement("button", { className: "hero_top_button", onClick: () => {
                                var _a;
                                // navigate(RoutePath.LOGIN)
                                return (_a = document
                                    .getElementById("contact-us-container")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                            } }, "Contact Us"))),
                react_1.default.createElement("div", { className: "hero_info_main_container" },
                    react_1.default.createElement("div", { className: `info_inner_container ${contentAnimation ? "content_animation" : ""}` },
                        react_1.default.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                            } },
                            react_1.default.createElement("h2", null, "Turning Data Into Direction"),
                            react_1.default.createElement("p", null, "Swivvl provides custom development services that transform your data into actionable insights, driving efficiency and scalable growth.")),
                        react_1.default.createElement("div", { className: "hero_info_btn_container" },
                            react_1.default.createElement("button", { className: "hero_top_button hero_info_btn_overlay", onClick: () => {
                                    var _a;
                                    (_a = document
                                        .getElementById("contact-us-container")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                                } }, "Contact Us")))),
                react_1.default.createElement("div", { className: "hero_bottom_scroll_container", onClick: () => {
                        var _a;
                        (_a = document.getElementById("founders-container")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                    } },
                    react_1.default.createElement("img", { src: "/assets/images/down_arrow.svg", alt: "" }))))));
});
// return (
//   <>
//     {/* <svg className="svg" style={{ position: "absolute" }}>
//       <clipPath id="s-curve-clip" clipPathUnits="objectBoundingBox">
//         <path d="M1,0.012 H0.001 v0.562 C0.001,0.263,0.015,0.012,0.033,0.012 h0.121 c0.008,-0.001,0.019,0.021,0.025,0.146 c0.01,0.189,0.003,0.455,0.014,0.663 c0.006,0.132,0.016,0.191,0.027,0.191 h0.562 c0.011,0,0.021,-0.059,0.027,-0.191 c0.01,-0.208,0.003,-0.474,0.014,-0.663 c0.007,-0.125,0.017,-0.148,0.025,-0.146 h0.121 c0.018,0,0.032,0.252,0.032,0.562 V0.012"></path>
//       </clipPath>
//     </svg> */}
//     {/* <div className="s-curve-div"> */}
//     <div className="hero_main_container">
//       {/* mobile nav start */}
//       <div className="mobile_nav">
//         {/* logo container */}
//         <div style={{ marginLeft: "50px" }}>
//           <img
//             style={{ width: "120px" }}
//             src={"/assets/images/swivvl_logo_1.png"}
//             alt="logo"
//           />
//         </div>
//         {/* menu button */}
//         <div style={{ marginRight: "50px" }}>
//           <button style={{ border: "none" }} onClick={navToggleHandler}>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="#ffffff"
//               viewBox="0 0 24 24"
//               strokeWidth="1.5"
//               stroke="#000000"
//               style={{ width: "24px", height: "24px" }}>
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
//               />
//             </svg>
//           </button>
//         </div>
//         {/* list container */}
//         <div
//           className={`mobile_nav_list_container ${
//             navToggle ? "mobile_nav_active" : ""
//           }`}>
//           <div style={{ width: "100%", textAlign: "end" }}>
//             <button
//               style={{
//                 background: "transparent",
//                 border: "none",
//                 marginRight: "80px",
//               }}
//               onClick={navToggleHandler}>
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 strokeWidth={1.5}
//                 stroke="#ffffff"
//                 style={{ width: "32px", height: "32px" }}>
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M6 18 18 6M6 6l12 12"
//                 />
//               </svg>
//             </button>
//           </div>
//           <ul className="mobile_nav_lists">
//             {navItems.map((item, i) => (
//               <li key={i}>{item.name}</li>
//             ))}
//           </ul>
//           <button className="hero_top_button">Get Started</button>
//         </div>
//       </div>
//       {/* mobile nav end */}
//       {/* inner container */}
//       <div className="hero_inner_container">
//         {/* top container start */}
//         <div className="hero_top_container">
//           {/* logo area */}
//           <div className="hero_logo_container">
//             <img src={"/assets/images/swivvl_logo_1.png"} alt="logo" />
//           </div>
//           {/* nav items */}
//           <div className="hero_nav_lists">
//             <ul>
//               {navItems.map((item, i) => (
//                 <li key={i}>{item.name}</li>
//               ))}
//             </ul>
//           </div>
//           {/* button area */}
//           <div className="hero_button_container">
//             <button className="hero_top_button">Get Started</button>
//           </div>
//         </div>
//         {/* top container end */}
//         {/* info container start */}
//         <div className="hero_info_main_container">
//           <div
//             className={`info_inner_container ${
//               contentAnimation ? "content_animation" : ""
//             }`}>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "12px",
//               }}>
//               <h2>Unlock Better Freight Opportunities with Swivvl</h2>
//               <p>
//                 Harness the power of cutting-edge AI to supercharge your
//                 freight brokerage business. With Swivvl, you set the
//                 direction, and we take care of the rest.
//               </p>
//             </div>
//             {/* buttons container */}
//             <div className="hero_info_btn_container">
//               <button className="hero_top_button hero_info_btn_overlay">
//                 Try For Free
//               </button>
//               <button className="hero_top_button hero_info_btn_outline">
//                 Explore Features
//               </button>
//             </div>
//           </div>
//         </div>
//         {/* info container end */}
//         {/* map markers container start */}
//         <div className="hero_map_markers_container">
//           {/* button one */}
//           <button
//             className={`hero_map_marker map_marker_one ${
//               markerAnimation ? "marker_animation" : ""
//             }`}>
//             <svg
//               width="16"
//               height="19"
//               viewBox="0 0 16 19"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg">
//               <path
//                 d="M15.9985 14.1258C15.9985 16.2829 8.87839 17.8876 6.58278 18.3482C6.2185 18.422 5.8783 18.142 5.8783 17.7702V13.7284C5.8783 13.7284 10.5071 12.911 13.5027 11.5848C14.8108 12.1433 15.9985 12.9667 15.9985 14.1243"
//                 fill="white"
//               />
//               <path
//                 d="M10.1217 10.1307C10.1217 10.4107 10.3189 10.6515 10.5929 10.7072C11.2281 10.8382 12.4083 11.1182 13.5042 11.5879C14.8123 12.1463 16 12.9697 16 14.1273V8.77893C16 6.20785 10.1232 5.27155 10.1232 5.27155V10.1322L10.1217 10.1307Z"
//                 fill="white"
//               />
//               <path
//                 d="M0.00146484 4.87415C0.00146484 2.71703 7.12161 1.11237 9.41722 0.651743C9.78151 0.577982 10.1217 0.857971 10.1217 1.22978V5.27156C10.1217 5.27156 5.49286 6.08894 2.49728 7.41513C1.18916 6.85665 0.00146484 6.03325 0.00146484 4.87566"
//                 fill="white"
//               />
//               <path
//                 d="M0.00150219 10.2226C0.00150219 12.7937 5.87826 13.73 5.87826 13.73V8.86929C5.87826 8.5893 5.68106 8.34845 5.40709 8.29275C4.77185 8.16179 3.59168 7.88181 2.49581 7.41215C1.18769 6.85368 0 6.03027 0 4.87268V10.2211L0.00150219 10.2226Z"
//                 fill="white"
//               />
//             </svg>
//             <span>66</span>
//           </button>
//           {/* button two */}
//           <button
//             className={`hero_map_marker map_marker_two ${
//               markerAnimation ? "marker_animation" : ""
//             }`}>
//             <svg
//               width="16"
//               height="19"
//               viewBox="0 0 16 19"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg">
//               <path
//                 d="M15.9985 14.1258C15.9985 16.2829 8.87839 17.8876 6.58278 18.3482C6.2185 18.422 5.8783 18.142 5.8783 17.7702V13.7284C5.8783 13.7284 10.5071 12.911 13.5027 11.5848C14.8108 12.1433 15.9985 12.9667 15.9985 14.1243"
//                 fill="white"
//               />
//               <path
//                 d="M10.1217 10.1307C10.1217 10.4107 10.3189 10.6515 10.5929 10.7072C11.2281 10.8382 12.4083 11.1182 13.5042 11.5879C14.8123 12.1463 16 12.9697 16 14.1273V8.77893C16 6.20785 10.1232 5.27155 10.1232 5.27155V10.1322L10.1217 10.1307Z"
//                 fill="white"
//               />
//               <path
//                 d="M0.00146484 4.87415C0.00146484 2.71703 7.12161 1.11237 9.41722 0.651743C9.78151 0.577982 10.1217 0.857971 10.1217 1.22978V5.27156C10.1217 5.27156 5.49286 6.08894 2.49728 7.41513C1.18916 6.85665 0.00146484 6.03325 0.00146484 4.87566"
//                 fill="white"
//               />
//               <path
//                 d="M0.00150219 10.2226C0.00150219 12.7937 5.87826 13.73 5.87826 13.73V8.86929C5.87826 8.5893 5.68106 8.34845 5.40709 8.29275C4.77185 8.16179 3.59168 7.88181 2.49581 7.41215C1.18769 6.85368 0 6.03027 0 4.87268V10.2211L0.00150219 10.2226Z"
//                 fill="white"
//               />
//             </svg>
//             <span>99</span>
//           </button>
//           {/* button three */}
//           <button
//             className={`hero_map_marker map_marker_three ${
//               markerAnimation ? "marker_animation" : ""
//             }`}>
//             <svg
//               width="16"
//               height="19"
//               viewBox="0 0 16 19"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg">
//               <path
//                 d="M15.9985 14.1258C15.9985 16.2829 8.87839 17.8876 6.58278 18.3482C6.2185 18.422 5.8783 18.142 5.8783 17.7702V13.7284C5.8783 13.7284 10.5071 12.911 13.5027 11.5848C14.8108 12.1433 15.9985 12.9667 15.9985 14.1243"
//                 fill="white"
//               />
//               <path
//                 d="M10.1217 10.1307C10.1217 10.4107 10.3189 10.6515 10.5929 10.7072C11.2281 10.8382 12.4083 11.1182 13.5042 11.5879C14.8123 12.1463 16 12.9697 16 14.1273V8.77893C16 6.20785 10.1232 5.27155 10.1232 5.27155V10.1322L10.1217 10.1307Z"
//                 fill="white"
//               />
//               <path
//                 d="M0.00146484 4.87415C0.00146484 2.71703 7.12161 1.11237 9.41722 0.651743C9.78151 0.577982 10.1217 0.857971 10.1217 1.22978V5.27156C10.1217 5.27156 5.49286 6.08894 2.49728 7.41513C1.18916 6.85665 0.00146484 6.03325 0.00146484 4.87566"
//                 fill="white"
//               />
//               <path
//                 d="M0.00150219 10.2226C0.00150219 12.7937 5.87826 13.73 5.87826 13.73V8.86929C5.87826 8.5893 5.68106 8.34845 5.40709 8.29275C4.77185 8.16179 3.59168 7.88181 2.49581 7.41215C1.18769 6.85368 0 6.03027 0 4.87268V10.2211L0.00150219 10.2226Z"
//                 fill="white"
//               />
//             </svg>
//             <span>89</span>
//           </button>
//           {/* popup */}
//           <div
//             className={`hero_popup_container ${
//               popoverAnimation ? "popup_active_animation" : ""
//             }`}>
//             <div className="popup_anchor"></div>
//             {/* popup inner container start */}
//             <div className="popup_inner_container">
//               {/* title */}
//               <div className="popup_title_container">
//                 <h4>Your Company</h4>
//                 <button
//                   className="hero_map_marker"
//                   style={{ position: "static", background: "#0b9b89" }}>
//                   <svg
//                     width="16"
//                     height="19"
//                     viewBox="0 0 16 19"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg">
//                     <path
//                       d="M15.9985 14.1258C15.9985 16.2829 8.87839 17.8876 6.58278 18.3482C6.2185 18.422 5.8783 18.142 5.8783 17.7702V13.7284C5.8783 13.7284 10.5071 12.911 13.5027 11.5848C14.8108 12.1433 15.9985 12.9667 15.9985 14.1243"
//                       fill="white"
//                     />
//                     <path
//                       d="M10.1217 10.1307C10.1217 10.4107 10.3189 10.6515 10.5929 10.7072C11.2281 10.8382 12.4083 11.1182 13.5042 11.5879C14.8123 12.1463 16 12.9697 16 14.1273V8.77893C16 6.20785 10.1232 5.27155 10.1232 5.27155V10.1322L10.1217 10.1307Z"
//                       fill="white"
//                     />
//                     <path
//                       d="M0.00146484 4.87415C0.00146484 2.71703 7.12161 1.11237 9.41722 0.651743C9.78151 0.577982 10.1217 0.857971 10.1217 1.22978V5.27156C10.1217 5.27156 5.49286 6.08894 2.49728 7.41513C1.18916 6.85665 0.00146484 6.03325 0.00146484 4.87566"
//                       fill="white"
//                     />
//                     <path
//                       d="M0.00150219 10.2226C0.00150219 12.7937 5.87826 13.73 5.87826 13.73V8.86929C5.87826 8.5893 5.68106 8.34845 5.40709 8.29275C4.77185 8.16179 3.59168 7.88181 2.49581 7.41215C1.18769 6.85368 0 6.03027 0 4.87268V10.2211L0.00150219 10.2226Z"
//                       fill="white"
//                     />
//                   </svg>
//                   <span>99</span>
//                 </button>
//               </div>
//               {/* count start */}
//               <div className="popup_count_container">
//                 {/* others */}
//                 <div className="popup_count_others">
//                   <img
//                     src="/assets/images/hero-popup/others_icon.svg"
//                     alt="others"
//                   />
//                   <span>Other</span>
//                 </div>
//                 {/* users */}
//                 <div className="popup_count_others">
//                   <img
//                     src="/assets/images/hero-popup/user_icon.svg"
//                     alt="others"
//                   />
//                   <span>1000+</span>
//                 </div>
//               </div>
//               {/* count end */}
//               {/* chart container start */}
//               <div className="popup_chart_container">
//                 {/* pie chart */}
//                 <div className="popup_chart">
//                   <p>Industries</p>
//                   <img
//                     src="/assets/images/hero-popup/pie_chart.svg"
//                     alt="pie-chart"
//                   />
//                 </div>
//                 {/* progress chart */}
//                 <div className="popup_chart">
//                   <p>Flow</p>
//                   <img
//                     src="/assets/images/hero-popup/progress_chart.svg"
//                     alt="pie-chart"
//                   />
//                 </div>
//               </div>
//               {/* chart container end */}
//               <button className="popup_button">More Details</button>
//               {/* anchor */}
//             </div>
//             {/* popup inner container end */}
//           </div>
//         </div>
//         {/* map markers container end */}
//       </div>
//     </div>
//     <Benefits />
//     {/* <Benefits />
//       <KeyFeatures />
//       <Pricing />
//       <Testimonials /> */}
//     <FAQ />
//     {/* <CTA />
//       <Footer /> */}
//     {/* </div> */}
//   </>
//   // <div className="hero-section">
//   //   <div className="square-with-circle">
//   //     {/* The actual square and circle are created with CSS */}
//   //   </div>
//   //   <img className="hero-image"></img>
//   //   <nav className="navigation">
//   //     <div className="left-side-nav">
//   //       <div className="top-left"></div>
//   //       <div className="logo">swivvl</div>
//   //     </div>
//   //     <div className="nav-links">
//   //       <div className="curve"></div>
//   //       <div className="middle-links"></div>
//   //       <div className="inner-links">
//   //         {" "}
//   //         <a href="#home">Home</a>
//   //         <a href="#about-us">About Us</a>
//   //         <a href="#pricing">Pricing</a>
//   //         <a href="#faq">FAQ</a>
//   //       </div>
//   //     </div>
//   //     <button className="get-started">Get Started</button>
//   //   </nav>
//   //   <header className="header-content">
//   //     <h1>Unlock Better Freight Opportunities with Swivvl</h1>
//   //     <p>
//   //       Harness the power of cutting-edge AI to supercharge your freight
//   //       brokerage business. With Swivvl, you set the direction, and we take
//   //       care of the rest.
//   //     </p>
//   //     <button className="try-for-free">Try For Free</button>
//   //     <button className="explore-features">Explore Features</button>
//   //   </header>
//   //   <aside className="stats-widget">
//   //     <div className="company-stats">
//   //       <h2>Your Company</h2>
//   //       <p>
//   //         <strong>92</strong> Industries
//   //       </p>
//   //       <p>
//   //         <strong>1,000</strong> Other
//   //       </p>
//   //       <p>
//   //         <strong>545</strong> Deliveries
//   //       </p>
//   //       <button className="more-details">More Details</button>
//   //     </div>
//   //   </aside>
//   // </div>
// );
